import {Suspense} from 'react';
import {GTMProvider} from '@elgorditosalsero/react-gtm-hook';
import {CssBaseline, ThemeProvider} from '@material-ui/core';
import {QueryClientProvider} from 'react-query';
import {BrowserRouter as Router} from 'react-router-dom';
import ErrorBoundary from 'shared/components/ErrorBoundary';
import Helmet from 'shared/components/Helmet';
import UserRoutes from 'shared/components/router/UserRoutes';
import AppLoading from 'shared/components/ui/AppLoading';
import AddToHomePromptContextProvider from 'shared/contexts/AddToHomePromptContext/AddToHomePromptContextProvider';
import {BackendClientContextProvider} from 'shared/contexts/BackendClientContext';
import {UserContextProvider} from 'shared/contexts/UserContext';
import usePushPageViewToDataLayer from 'shared/hooks/usePushPageViewToDataLayer';
import legitTheme from 'shared/theme/legitTheme';
import queryClient from 'shared/utils/reactQuery/queryClient';

function AppTracker() {
  usePushPageViewToDataLayer();
  return null;
}

function App() {
  const gtmParams = {id: 'GTM-MZMLMDQ'};
  return (
    <GTMProvider state={gtmParams}>
      <ThemeProvider theme={legitTheme}>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<AppLoading />}>
            <AddToHomePromptContextProvider>
              <CssBaseline />
              <Router>
                <ErrorBoundary>
                  <BackendClientContextProvider>
                    <UserContextProvider>
                      <AppTracker />
                      <Helmet />
                      <UserRoutes />
                    </UserContextProvider>
                  </BackendClientContextProvider>
                </ErrorBoundary>
              </Router>
            </AddToHomePromptContextProvider>
          </Suspense>
        </QueryClientProvider>
      </ThemeProvider>
    </GTMProvider>
  );
}

export default App;
